<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/experts">Эксперты</router-link>
          <span></span>
          <h1>Создание эксперта</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius">
          <div class="column caption">
            <p>Основные настройки</p>
          </div>
          <div class="column">
            <div class="content">
              <form-input name="title"></form-input>
              <form-file use-case="cover" name="img"></form-file>
              <form-input name="url"></form-input>
              <form-input name="seo_alt"></form-input>
              <form-input name="mail"></form-input>
              <form-input name="facebook"></form-input>
              <form-input name="vk"></form-input>
              <form-input name="youTube"></form-input>
              <form-input name="liveJournal"></form-input>
              <form-input name="ok"></form-input>
              <form-input name="skype"></form-input>
            </div>
          </div>

        </div>
        <div class="folder radius">
          <div class="column caption">
            <p>СЕО настройки</p>
          </div>
          <div class="column">
            <div class="content">
              <form-input name="seo_title"></form-input>
              <form-text-area name="seo_desc"></form-text-area>
              <form-text-area name="seo_key"></form-text-area>
            </div>
          </div>
        </div>
        <div class="folder radius">
          <div class="column caption">
            <p>Текст статьи</p>
          </div>
          <div class="column">
            <div class="content">
              <form-text-editor name="text" editor-id="editor"></form-text-editor>
              <add-image v-if="isLoaded"/>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onAddItem">Сохранить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import Checkbox from '@/components/create-form/Checkbox'
  import AddImage from '@/components/edit-form/AddImage'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    data: function () {
      return {
        editorInstance: '',
        isLoaded: false,
        text: '',
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      },
      ...mapState([
        'textContent',
        'fields'
      ]),
    },
    mounted () {
      this.isLoaded = true
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setCurrentParentId',
        'setFileExtensions',
        'setUrl'
      ]),
      onAddItem () {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.addItem()
          .then(() => {
            this.$router.push('/experts')
          })
      },
    },
    created () {
      this.setUrl(this.apiUrls.content)
      this.setCurrentParentId(this.parentId.experts)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Имя эксперта',
          errorId: null,
          errors: {empty: 'Введите название семинара'},
          tabId: 0
        },
        mail: {
          value: '',
          parameterName: 'mail',
          name: 'Email',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        url: {
          value: '',
          parameterName: 'url',
          name: 'Ссылка',
          errorId: null,
          errors: {empty: 'Напишите alt для картинки'},
          tabId: 0,
          isNullable: true
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Alt',
          errorId: null,
          errors: {empty: 'Напишите alt для картинки'},
          tabId: 0,
          isNullable: true
        },
        facebook: {
          value: '',
          parameterName: 'facebook',
          name: 'Facebook',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        vk: {
          value: '',
          parameterName: 'vk',
          name: 'Вконтакте',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        youTube: {
          value: '',
          parameterName: 'youTube',
          name: 'YouTube',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        liveJournal: {
          value: '',
          parameterName: 'liveJournal',
          name: 'Live Journal',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        ok: {
          value: '',
          parameterName: 'ok',
          name: 'Одноклассники',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        skype: {
          value: '',
          parameterName: 'skype',
          name: 'Skype',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
      })
    },
    components: {
      Checkbox,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      AddImage
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/experts/pages/Create.vue